var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('Tabs',{staticStyle:{"width":"100%","height":"100%"},attrs:{"value":_vm.currentTabl}},[_c('TabPane',{attrs:{"label":"用水量上报","name":"water"}},[_c('Water')],1),_c('TabPane',{attrs:{"label":"销售上报","name":"sell"}},[_c('Sell')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }